import React, { useEffect, useRef, useState } from 'react';
import './choosecharchter.css';
import { useNavigate } from 'react-router-dom';

import Settings from '../components/common/settings';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';
import selectSound from '../audios/creatorshome-select-003-337609.mp3'; // add your select sound

const Charchter = () => {
  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  const lockedAudio = useRef(new Audio(lockedSound));
  const settingsAudio = useRef(new Audio(settingsSound));
  const selectAudio = useRef(new Audio(selectSound));

  useEffect(() => {
    setLoaded(true);
  }, []);

  const playLockedSound = () => {
    lockedAudio.current.currentTime = 0;
    lockedAudio.current.play().catch(() => {});
  };

  const playSettingsSound = () => {
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const playSelectSound = () => {
    selectAudio.current.currentTime = 0;
    selectAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const selectCharacter = (character) => {
    playSelectSound();
    setSelectedCharacter(character);
  };

  const handleNext = () => {
    playSettingsSound();

    localStorage.setItem('selectedCharacter', selectedCharacter);

    navigate('/levels');
  };

  return (
    <section className="section2">

      <div className="overlay"></div>
      <div className="fog"></div>
      <div className="flicker-overlay"></div>

      <div className="levelsnav">

        <button
          className="backbt"
          onClick={() => {
            playSettingsSound();
            navigate(-1);
          }}
        >
          BACK
        </button>

        <h1 className="mysteryhotel">
          MYSTERY HOTEL
        </h1>

        <div
          className="settings"
          onClick={openSettingsMenu}
        />

      </div>

      <h1 className="pickurroom">
        CHOOSE YOUR CHARACTER
      </h1>

      <div className="chardiv">
        <div className="cdic1">

          <div
            className={`charchter1 ${
              selectedCharacter === 'character1' ? 'selected' : ''
            }`}
            onClick={() => selectCharacter('character1')}
          />

          <div
            className={`charchter2 ${
              selectedCharacter === 'character2' ? 'selected' : ''
            }`}
            onClick={() => selectCharacter('character2')}
          />

        </div>
      </div>

      {selectedCharacter && (
        <button
          className="nextbt"
          onClick={handleNext}
        >
          NEXT
        </button>
      )}

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

    </section>
  );
};

export default Charchter;